import { FireFilled, FireOutlined } from '@ant-design/icons'
import { useLockFn, useRequest } from 'ahooks'
import { Badge, Tooltip } from 'antd'
import axios from 'axios'
import { useAtom } from 'jotai'
import { isNil } from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { userInfoAtom } from '@/modules/user'
import { ResourceType } from '@/schemas'

interface HotResourceProps {
  selfId: any
  type: ResourceType
  hotData?: any[]
  readonly?: boolean
}

export const HotResource: React.FC<HotResourceProps> = ({ type, selfId, hotData, readonly = false }) => {
  const { t } = useTranslation()
  const [viewer] = useAtom(userInfoAtom)
  const [isHot, setIsHot] = React.useState(false)
  const [hotCount, setHotCount] = React.useState(0)
  const [offset, setOffset] = React.useState([0, 0])
  const [marginRight, setMarginRight] = React.useState(0)
  const { data, refresh } = useRequest(
    {
      url: '/api/hot/getPpHot',
      params: {
        selfId,
        type,
      },
    },
    {
      manual: !isNil(hotData),
      refreshDeps: [selfId, type],
    }
  )

  React.useEffect(() => {
    if (data) {
      const isHot = !!data.find((d: any) => d.email === viewer.email)
      setHotCount(data.length)
      setIsHot(isHot)
    }
  }, [data])

  React.useEffect(() => {
    if (hotData) {
      const isHot = !!hotData.find((d: any) => d.email === viewer.email)
      setHotCount(hotData.length)
      setIsHot(isHot)
    }
  }, [hotData])

  React.useEffect(() => {
    if (hotCount < 10) {
      setOffset([2, 0])
      setMarginRight(0)
    } else if (hotCount < 100) {
      setOffset([10, 0])
      setMarginRight(4)
    } else {
      setOffset([14, 0])
      setMarginRight(6)
    }
  }, [hotCount])

  const onClick = useLockFn(async () => {
    if (readonly) return
    await axios.request({
      url: isHot ? '/api/hot/deletePpHot' : '/api/hot/createPpHot',
      method: 'POST',
      data: {
        selfId,
        type,
      },
    })
    refresh()
  })

  const Filled = <FireFilled className='text-red-400' onClick={onClick} />
  const Outlined = <FireOutlined onClick={onClick} />

  return (
    <Badge className={`${hotCount ? `!mr-${marginRight}` : ''}`} offset={offset as any} size='small' count={hotCount}>
      {readonly ? (
        isHot ? (
          Filled
        ) : (
          Outlined
        )
      ) : isHot ? (
        <Tooltip title={t('unHot')}>{Filled}</Tooltip>
      ) : (
        <Tooltip title={t('hot')}>{Outlined}</Tooltip>
      )}
    </Badge>
  )
}
